import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { removeDefaultParams } from '../../../Utils/helper';
import { fireClickedEvent } from '../instrumentation';
import { L2CategoryInner } from './styled';

export default function L2Category(props) {
  const { element, index, categoryId } = props;
  const router = useRouter();
  const [isSelected, setIsSelected] = useState(false);
  const scrollRef = useRef();

  const findCategory = () => {
    if (element?._id === categoryId) {
      setIsSelected(true);
    } else {
      element?.subCategories?.map((subCategories, index) => {
        if (subCategories?._id === categoryId) {
          setIsSelected(true);
        }
      });
    }
  };
  useEffect(() => {
    setIsSelected(false);
    findCategory();
  }, [element]);

  useEffect(() => {
    scrollRef?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
      inline: 'center',
    });
  }, []);

  return (
    <Link
      href={{
        pathname: element?.key,
        query: removeDefaultParams(router.query),
      }}
      passHref
      key={`catdropdownL2${index}`}
      locale={false}
      legacyBehavior
    >
      <L2CategoryInner
        ref={isSelected ? scrollRef : null}
        as="a"
        className={isSelected ? 'selected' : null}
        key={index}
        onClick={() => fireClickedEvent(element?.key, element?.tabName, true)}
      >
        {element?.tabName.toLowerCase()}
      </L2CategoryInner>
    </Link>
  );
}
